// Mock Authentication Helper for Demo Build
// This bypasses real backend API calls for client demos

const DEMO_USERS = {
  "admin@admin.com": {
    username: "admin@admin.com",
    password: "123456",
    accessToken: "demo-token-" + Math.random().toString(36).substring(7),
    refreshToken: "demo-refresh-token-" + Math.random().toString(36).substring(7),
    user: {
      id: 1,
      username: "Admin User",
      email: "admin@admin.com",
      role: "admin",
      branchName: "Main Branch"
    }
  }
};

export const mockLogin = async (credentials) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const { username, password } = credentials;
      
      const user = DEMO_USERS[username];
      
      if (user && user.password === password) {
        const response = {
          accessToken: user.accessToken,
          refreshToken: user.refreshToken,
          user: user.user
        };
        console.log("[Mock Auth] Login successful for:", username);
        resolve(response);
      } else {
        console.log("[Mock Auth] Login failed for:", username);
        reject(new Error("Invalid credentials"));
      }
    }, 500); // Simulate network delay
  });
};

export const mockLogout = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("[Mock Auth] Logout successful");
      resolve({ success: true });
    }, 300);
  });
};

export const isMockAuthEnabled = () => {
  // Use mock auth if explicitly enabled OR if in production without backend URL
  return process.env.REACT_APP_USE_MOCK_AUTH === "true" || 
         (process.env.NODE_ENV === "production" && !process.env.REACT_APP_BACKEND_URL);
};
